import { Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, Modal, Typography } from "@mui/material";
import { useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  "@media screen and (max-width:600px)": {
    width: "90%",
  },
};

function ModalWithCheckbox({ open, setOpen, selectedItems, setSelectedItems, getData, title = "Select Options", saveCallback }) {
  const [loder, setLoder] = useState(false);
  const handleClose = () => setOpen(false);
  const handleCheckboxChange = event => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedItems(prev => [...prev, value]);
    } else {
      setSelectedItems(prev => prev.filter(item => item !== value));
    }
  };

  const handleSave = () => {
    setLoder(true);
    if (selectedItems) {
      saveCallback();
    }
    setLoder(false);
    handleClose();
  };

  return (
    <div>
      <Modal open={open}>
        <Box sx={style}>
          <Typography variant="h6" component="h2">
            {title}
          </Typography>
          <FormControl
            component="fieldset"
            sx={{
              maxHeight: 200,
              overflowY: "auto",
              mb: 2,
            }}
          >
            {getData && getData.length > 0 ? (
              getData.map(item => (
                <FormControlLabel
                  key={item.siteUrl}
                  control={<Checkbox value={item.siteUrl} onChange={handleCheckboxChange} checked={selectedItems.includes(item.siteUrl)} />}
                  label={item.siteUrl}
                />
              ))
            ) : (
              <Typography>No data available</Typography>
            )}
          </FormControl>
          <Box mt={2}>
            <Button variant="contained" color="primary" disabled={loder || selectedItems.length === 0} onClick={handleSave} sx={{ mr: 2 }}>
              {loder ? <CircularProgress /> : "Save"}
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleClose}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default ModalWithCheckbox;
